import { Logo } from "../common/Logo";
import { LangSwitch } from "../common/LangSwitch";

export const AuthCard = ({ title, subtitle, children, testId }) => (
  <div className="min-h-screen bg-canvas px-5 py-6">
    <div className="mx-auto flex max-w-sm items-center justify-between">
      <Logo light={false} />
      <LangSwitch />
    </div>
    <div className="mx-auto mt-10 w-full max-w-sm rounded-3xl bg-white p-6 shadow-[0_8px_30px_rgba(11,37,69,0.08)] sm:p-8" data-testid={testId}>
      <h1 className="text-2xl font-bold text-navy">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      {children}
    </div>
  </div>
);
